import React from 'react';
import { CircularProgress } from '@mui/material';
var LoadingIndicator = function () { return React.createElement(CircularProgress, { size: "1em" }); };
export default LoadingIndicator;
